import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CodigoPostalList } from "./listCodigos/list";

type Entity = models.RutaEntregaDomicilio;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un RutaEntregaDomicilioDto
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        IdSucursal: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class RutaEntregaDomicilioDtoFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Sucursal = getField(selectores.Sucursal);
        const Check = getField(kea.Checkbox);
        const CodigosPostales = getField(CodigoPostalList);


        return (
            <div>
                <kea.Title titulo="Ruta de entrega a domicilio" onRegresar={() => history.go("../")} />
                {kea.autogrid(3, [
                    <Text field="Nombre" />,
                    <Check field="AsignableDocumentacion" label="Asignable en documentación" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />
                ])}

                <CodigosPostales field="CodigosPostales" />
                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const RutaEntregaDomicilioDtoForm = componentToRx(RutaEntregaDomicilioDtoFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/rutaEAD/edit/form.tsx